module.exports = __webpack_public_path__ + "static/media/Poppins-Light.02c5a7af.otf";